import { useState, useEffect, useCallback } from "react";
import { callApi } from "../utils/api";
import { ToastsStore } from "react-toasts";
import ExcelJS from "exceljs";
import isEmpty from 'lodash/isEmpty';

declare var $: any;

interface VettingFile {
    id: string;
    serial_no: string;
    file_no: string;
    lh_branch: string;
    bank_name: string;
    borrower_name: string;
    property_owner: string;
    loginBy: string;
}

interface VettingFilesState {
    files: VettingFile[];
    totalDataCount: number;
    currentPage: number;
    isFileRefresh: boolean;
    isLoading: boolean;
    pickFileId: string;
    reworkFileId: string;
    searchTerm: string;
    unholdFile: string;
    unholdreason: string;
    viewFileId: string;
    isHoldLoading: boolean;
    isDownloading: boolean;
    vettingCategory: string;
    vettingSubCategory: any;
    vettingErrorCategory: any;
    mistakeBy: string;
    reWorkReason: string;
    required: boolean;
}

export const useVettingFiles = (status: number, limit: number = 20) => {
    const [state, setState] = useState<VettingFilesState>({
        files: [],
        totalDataCount: 0,
        currentPage: 1,
        isFileRefresh: false,
        isLoading: false,
        pickFileId: "",
        reworkFileId: "",
        searchTerm: "",
        unholdFile: "",
        unholdreason: "",
        viewFileId: "",
        isHoldLoading: false,
        isDownloading: false,
        vettingCategory: "",
        vettingSubCategory: [],
        vettingErrorCategory: [],
        mistakeBy: "",
        reWorkReason: "",
        required: false,
    });

    const user = localStorage.getItem("user");
    const userId = user ? JSON.parse(user).userId : "";

    const downloadExcel = () => {
        const { currentPage, searchTerm } = state;
        const userid1: any = localStorage.getItem("user1");
        let user_id = JSON.parse(userid1);
        let req = {
            userId: user_id,
            page: currentPage,
            limit: limit,
            searchTerm: searchTerm
        };

        setState((prev) => ({ ...prev, isDownloading: true }));

        callApi("POST", "vetting_get_unhold_files_excel.php", req)
            .then((res) => res.data)
            .then(async (response) => {
                const { data: files, totalRecords, currentPage: apiCurrentPage } = response;
                if (files && files.length > 0) {
                    if (!Array.isArray(files)) {
                        console.error("Data is not an array:", files);
                        return;
                    }

                    const workbook = new ExcelJS.Workbook();
                    const worksheet = workbook.addWorksheet('Sheet1');

                    // Define columns with headers
                    worksheet.columns = [
                        { header: 'S.No', key: 's_no', width: 10 },
                        { header: 'File No', key: 'file_id', width: 10 },
                        { header: 'Bank Name', key: 'bank_name', width: 30 },
                        { header: 'Product', key: 'product_name', width: 15 },
                        { header: 'Law Hands Branch Name', key: 'lh_branch', width: 15 },
                        { header: 'Bank Branch Name', key: 'bank_branch', width: 15 },
                        { header: 'Property Owner Name', key: 'owner_name', width: 15 },
                        { header: 'Borrower Name', key: 'borrower_name', width: 15 },
                        { header: 'Hold By', key: 'hold_by', width: 15 },
                        { header: 'Hold Date', key: 'hold_dt', width: 15 },
                        { header: 'Hold Reason', key: 'hold_reason', width: 15 },
                        { header: 'UnHold By', key: 'unhold_by', width: 15 },
                        { header: 'UnHold Date', key: 'unhold_dt', width: 15 },
                        { header: 'UnHold Reason', key: 'unhold_reason', width: 15 },
                    ];

                    // Apply alignment and color to header cells
                    worksheet.getRow(1).eachCell((cell) => {
                        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFFF00' }, // Yellow color
                        };
                        cell.font = { bold: true, size: 14 };
                    });

                    const flattenedData = files.map((file, index) => {
                        const hold_by = file.all_hold
                            .map(
                                (doc, docIndex) => `${doc.hold_by}`
                            )
                            .join("\n");
                        const hold_dt =
                            file.all_hold && file.all_hold.length > 0
                                ? file.all_hold
                                    .map((query, queryIndex) => `${query.hold_dt}`)
                                    .join("\n")
                                : "Nil";
                        const hold_reason =
                            file.all_hold && file.all_hold.length > 0
                                ? file.all_hold
                                    .map((query, queryIndex) => `${queryIndex + 1}. ${query.hold_reason}`)
                                    .join("\n")
                                : "Nil";
                        const unhold_by = file.all_hold
                            .map(
                                (doc, docIndex) => `${doc.unhold_by}`
                            )
                            .join("\n");
                        const unhold_dt =
                            file.all_hold && file.all_hold.length > 0
                                ? file.all_hold
                                    .map((query, docIndex) => `${query.unhold_dt}`)
                                    .join("\n")
                                : "Nil";
                        const unhold_reason =
                            file.all_hold && file.all_hold.length > 0
                                ? file.all_hold
                                    .map((query, docIndex) => `${docIndex + 1}. ${query.unhold_reason}`)
                                    .join("\n")
                                : "Nil";
                        return {
                            s_no: index + 1,
                            file_id: file.file_id,
                            bank_name: file.bank_name,
                            product_name: file.product_name,
                            lh_branch: file.lh_branch,
                            bank_branch: file.bank_branch,
                            owner_name: file.owner_name,
                            borrower_name: file.borrower_name,
                            hold_by: hold_by,
                            hold_dt: hold_dt,
                            hold_reason: hold_reason,
                            unhold_by: unhold_by,
                            unhold_dt: unhold_dt,
                            unhold_reason: unhold_reason,
                        };
                    });

                    // Add data rows with custom cell alignment and wrap text
                    flattenedData.forEach(item => {
                        const row = worksheet.addRow(item);
                        row.eachCell((cell) => {
                            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        });
                    });
                    const currentDate = new Date();
                    const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
                    // Generate Excel file buffer
                    const buffer = await workbook.xlsx.writeBuffer();
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.href = url;
                    anchor.download = `Unhold Report ${formattedDate}.xlsx`;
                    anchor.click();
                    window.URL.revokeObjectURL(url);
                    setState((prev) => ({ ...prev, isDownloading: false }));
                }

            })
            .catch((err) => {
                console.log(err);
                setState((prev) => ({ ...prev, isDownloading: false }));
            });
    }

    const getFiles = useCallback(async (page: number, searchTerm: string) => {
        setState((prev) => ({ ...prev, isFileRefresh: false }));
        try {
            const api = status === 4 ? "vetting_get_hold_files.php" : (status === 5 ? "vetting_get_unhold_files.php" : "vettingGetByStatus.php");
            const response = await callApi("POST", api, {
                page,
                limit,
                userId,
                status,
                searchTerm,
            }).then((res) => res.data);

            if (response.result) {
                setState((prev) => ({
                    ...prev,
                    files: response.data,
                    totalDataCount: Number(response.totalRecords),
                    isFileRefresh: true,
                }));
            } else {
                setState((prev) => ({
                    ...prev,
                    files: [],
                    totalDataCount: 0,
                    currentPage: 1,
                    isFileRefresh: true,
                }));
            }
        } catch (err) {
            console.error(err);
            setState((prev) => ({ ...prev, isFileRefresh: true }));
        }
    }, [limit, status, userId]);

    const handlePageChange = useCallback((_: any, value: number) => {
        setState((prev) => ({ ...prev, currentPage: value }));
    }, []);

    const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const newSearchTerm = e.target.value;
        setState((prev) => ({ ...prev, searchTerm: newSearchTerm, currentPage: 1 }));
    }, []);

    const handleUnholdFile = useCallback(async () => {
        if (!state.unholdFile || !state.unholdreason) {
            ToastsStore.error("Please select a file and provide a reason to unhold.");
            return;
        }
        setState((prev) => ({ ...prev, isHoldLoading: true }));
        try {
            const response = await callApi("POST", "vetting_unhold_file.php", {
                user_id: userId,
                file_id: state.unholdFile,
                reason: state.unholdreason,
            }).then((res) => res.data);
            if (response.statuscode == 200 && response.file_taken_status == 0) {
                ToastsStore.success(response.message);
                $("#holdModal").modal("hide");
                setState((prev) => ({ ...prev, unholdFile: "", unholdreason: "", pickFileId: state.unholdFile }));
                setTimeout(() => {
                    window.location.href = `/vetting-overview/${state.unholdFile}`;
                    localStorage.setItem("vetting_takenfile_id", JSON.stringify(state.unholdFile));
                    // pickFile();
                    // getFiles(state.currentPage, state.searchTerm); // Refresh files after unholding
                }, 300);
            } else {
                ToastsStore.error(response.message);
            }
        } catch (err) {
            console.error(err);
            ToastsStore.error("An error occurred while unholding the file.");
        } finally {
            setState((prev) => ({ ...prev, isHoldLoading: false }));
        }
    }, [state, userId]);

    const pickFile = useCallback(async () => {
        setState((prev) => ({ ...prev, isLoading: true }));
        try {
            const response = await callApi("POST", "vettingPickup.php", {
                userId,
                fileId: state.pickFileId,
            }).then((res) => res.data);

            if (response.success) {
                ToastsStore.success(response.message);
                $("#pickModal").modal("hide");
                window.location.href = `/vetting-overview/${state.pickFileId}`;
                localStorage.setItem("vetting_takenfile_id", JSON.stringify(state.pickFileId));
            } else {
                ToastsStore.error(response.message);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setState((prev) => ({ ...prev, isLoading: false }));
        }
    }, [state.pickFileId, userId]);

    const handleRework = useCallback(async () => {
        const vettingCategory = (state.vettingCategory || '').trim();
        const reWorkReason = (state.reWorkReason || '').trim();

        if (isEmpty(vettingCategory) || isEmpty(reWorkReason) || isEmpty(state.vettingSubCategory) || isEmpty(state.vettingErrorCategory)) {
            setState((prev) => ({ ...prev, required: true }));
            ToastsStore.error("Please type required fields.");
            return;
        }

        setState((prev) => ({ ...prev, isLoading: true }));
        try {
            const response = await callApi("POST", "vettingRework.php", {
                userId,
                fileId: state.reworkFileId,
                vetting_category: state.vettingCategory,
                vetting_sub_category: state.vettingSubCategory,
                vettingErrorCategory: state.vettingErrorCategory,
                reWorkReason: state.reWorkReason,
                mistakeBy: state.mistakeBy,
            }).then((res) => res.data);

            if (response.success) {
                ToastsStore.success(response.message);
                $("#reworkModal").modal("hide");
                window.location.href = `/vetting-overview/${state.reworkFileId}`;
                localStorage.setItem("vetting_takenfile_id", JSON.stringify(state.reworkFileId));
            } else {
                ToastsStore.error(response.message);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setState((prev) => ({ ...prev, isLoading: false }));
        }
    }, [state.reworkFileId, state.vettingCategory, state.vettingSubCategory, state.vettingErrorCategory, state.reWorkReason, userId]);

    useEffect(() => {
        getFiles(state.currentPage, state.searchTerm); // Fetch on page or search term change
    }, [getFiles, state.currentPage, state.searchTerm]);

    return {
        ...state,
        getFiles,
        handlePageChange,
        handleSearch,
        pickFile,
        setPickFileId: (file: any) => setState((prev) => ({ ...prev, pickFileId: file.id, viewFileId: file?.file_no })),
        handleRework,
        setReworkFileId: (file: any) => setState((prev) => ({ ...prev, reworkFileId: file.id, viewFileId: file?.file_no })),
        getSelectedFile: (file: any) => {
            setState((prev) => ({ ...prev, unholdFile: file?.id, viewFileId: file?.file_no }));
        },
        onchange: (e: any) => {
            const { name, value } = e.target;
            setState(prev => ({ ...prev, [name]: value }));
        },
        handleUnholdFile,
        downloadExcel,
        setVettingCategory: (val: any) => {
            setState((prev) => ({ ...prev, vettingCategory: val, required: false }))
        },
        setVettingErrorCategory: (val: any) => {
            setState((prev) => ({ ...prev, vettingErrorCategory: val, required: false }))
        },
        setVettingSubCategory: (val: any) => {
            setState((prev) => ({ ...prev, vettingSubCategory: val, required: false }))
        },
        setMistakeBy: (val: any) => {
            setState((prev) => ({ ...prev, mistakeBy: val, required: false }))
        },
    };
};